import { Component, Input } from '@angular/core';
import { IntegrationAppWithInstallations } from 'src/app/integration-apps/pages/integration-apps-hub/integration-apps-hub.component';

@Component({
  selector: 'app-integration-apps-card-long',
  templateUrl: './integration-apps-card-long.component.html',
  standalone: false
})
export class IntegrationAppsCardLongComponent {

  @Input() public integrationApp: IntegrationAppWithInstallations;
  
}
